import {
  RECEIVE_FROM_API,
  RECEIVE_FROM_API_HOLDING_DATA,
  RECEIVE_INFOGRAPHICS_FROM_API,
  REQUEST_API,
  REQUEST_API_FAILURE,
  REQUEST_API_FAILURE_HOLDING_DATA,
  REQUEST_API_HOLDING_DATA,
  REQUEST_POST_ACR_INFO_BOX_SUCCESS,
} from 'src/constants';

import {
  CLEAR_API_KEYS,
  ClearApiKeysAction,
  CommentRequestAPIAction,
  CommentRequestAPIPayload,
  CommentRestoreRequestAPIPayload,
  IRequestParams,
  ReceiveDataNotesPayload,
  ReceiveDataNotesResponseAction,
  ReplyCommentRequestAPIAction,
  ReplyCommentRequestAPIPayload,
  RequestAPIAction,
  RequestAPILatestParams,
  ResetReportsListAction,
} from 'src/redux/data/types';

export const RESET_REPORTS_LIST = 'RESET_REPORTS_LIST';
export const RECEIVE_DATA_NOTES_FROM_API = 'RECEIVE_DATA_NOTES_FROM_API';
export const COMMENT_REQUEST_API = 'COMMENT_REQUEST_API';
export const COMMENT_REPLY_REQUEST_API = 'COMMENT_REPLY_REQUEST_API';
export const RESTORE_COMMENT_REQUEST_API = 'RESTORE_COMMENT_REQUEST_API';

export const REQUEST_API_LATEST = 'REQUEST_API_LATEST';

export const resetReportsList = (): ResetReportsListAction => {
  return {
    type: RESET_REPORTS_LIST,
  };
};

export const receiveDataNotesResponse = (
  dataKey: string,
  json: ReceiveDataNotesPayload,
  request_params: any,
): ReceiveDataNotesResponseAction => {
  return {
    type: RECEIVE_DATA_NOTES_FROM_API,
    dataKey,
    payload: json,
    request_params,
  };
};

export const clearApiKeys = (dataKeys: string[]): ClearApiKeysAction => {
  return {
    type: CLEAR_API_KEYS,
    dataKeys,
  };
};

export const requestAPI = (
  dataKey: string,
  params: IRequestParams = {},
): RequestAPIAction => {
  return {
    type: REQUEST_API,
    dataKey,
    params,
  };
};

export const requestAPILatest = (
  dataKey: string,
  params: RequestAPILatestParams,
) => {
  return {
    type: REQUEST_API_LATEST,
    dataKey,
    params,
  };
};

export const requestAPIHoldingData = (dataKey, id, params = {}) => {
  return {
    type: REQUEST_API_HOLDING_DATA,
    dataKey,
    id,
    params,
  };
};

export const requestAPIFailed = (dataKey, error, timestamp) => {
  return {
    type: REQUEST_API_FAILURE,
    dataKey,
    error,
    timestamp,
  };
};

export const requestAPIFailedHoldingData = (dataKey, error, timestamp = '') => {
  return {
    type: REQUEST_API_FAILURE_HOLDING_DATA,
    dataKey,
    error,
    timestamp,
  };
};

export const receiveAPIResponse = (dataKey, payload, request_params) => {
  return {
    type: RECEIVE_FROM_API,
    dataKey,
    payload,
    request_params,
  };
};

export const receiveAPIResponseHoldingData = (payload, dataKey) => {
  return {
    type: RECEIVE_FROM_API_HOLDING_DATA,
    payload,
    dataKey,
  };
};

export const commentRequestAPI = (
  params: CommentRequestAPIPayload,
): CommentRequestAPIAction => {
  return {
    type: COMMENT_REQUEST_API,
    params,
  };
};

export const commentReplyRequestAPI = (
  params: ReplyCommentRequestAPIPayload,
): ReplyCommentRequestAPIAction => {
  return {
    type: COMMENT_REPLY_REQUEST_API,
    params,
  };
};

export const commentRestoreRequestAPI = (
  params: CommentRestoreRequestAPIPayload,
) => {
  return {
    type: RESTORE_COMMENT_REQUEST_API,
    params,
  };
};

export const receivePostAcrInfoBoxSuccess = (payload, dataKey) => {
  return {
    type: REQUEST_POST_ACR_INFO_BOX_SUCCESS,
    payload,
    dataKey,
  };
};

export const receiveAPIInfographicsResponse = (
  dataKey,
  json,
  request_params,
) => {
  return {
    type: RECEIVE_INFOGRAPHICS_FROM_API,
    dataKey,
    payload: json,
    request_params,
  };
};

export * from './narrative';
export * from './publicationStatus';
export * from './subtitle';
